import { MBrandElementProps } from '../../molecules/MBrandElement/MBrandElement.types';
import { MTextBlockSimpleProps } from '../../molecules/MTextBlockSimple/MTextBlockSimple.types';
import { MButtonProps } from '../../molecules/MButton/MButton.types';
import { MButtonOverlayProps } from '../../molecules/MButtonOverlay/MButtonOverlay.types';

export enum OHeroVideoContentAlignment {
  Bottom = 'Bottom',
  Center = 'Center',
  Left = 'Left',
}

export enum OHeroVideoImageScale {
  Large = 'Large',
  Small = 'Small',
}

export interface OHeroVideoAVideoProps {
  aspectRatio?: string;
  videoType?: string;
  videoAccountId?: string;
  videoId?: string;
  playerId?: string;
  videoCaption?: string;
}

export interface OHeroVideoAScrimGradientProps {
  direction?: string;
}

export type OHeroVideoProps = {
  contentAlignment?: OHeroVideoContentAlignment | string;
  imageScale?: OHeroVideoImageScale | string;
  logo?: boolean;
  secondaryButton?: boolean;
  aVideo?: OHeroVideoAVideoProps;
  aScrimGradient?: OHeroVideoAScrimGradientProps;
  mBrandElement?: MBrandElementProps;
  mTextBlockSimple?: MTextBlockSimpleProps;
  mButton?: MButtonProps;
  mButtonOverlay?: MButtonOverlayProps;
  className?: string;
};
